import React from 'react';
import './App.css';

// App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Solutions from './pages/Solutions'
import SuccessStories from './pages/SuccessStories';
import Contact from './pages/Contact';
import Book from "./pages/Book"
import SpacetimeCityTwin from './pages/solutions/SpacetimeCityTwin';
import SpacetimeSafeCity from './pages/solutions/SpacetimeSafeCity';
import SpacetimeInfraPlan from './pages/solutions/SpacetimeInfraPlan';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/solutions' element={<Solutions />} />
        <Route path="/solutions/spacetime-city-twin" element={<SpacetimeCityTwin />} />
        <Route path="/solutions/spacetime-safe-city" element={<SpacetimeSafeCity />} />
        <Route path="/solutions/spacetime-infra-plan" element={<SpacetimeInfraPlan />} />
        <Route path="/about" element={<About />} />
        <Route path="/success-stories" element={<SuccessStories />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/book" element={<Book />} />
      </Routes>
    </Router>
  );
}


export default App;